import cordova from '../api/cordovaAPI';


const getLargeImageUrl = (uri) => {
    if(!uri || uri.indexOf('http') == 0) {
        return uri ||  "../../../no-clinic-img.svg"
    }
    let parts = uri.split('public://');
    

    if (parts.length==2) {
        return 'https://www.colfisiocv.com/sites/default/files/styles/large_retina/public/' + parts[1];
    } 

    return '';
}

const getLargeImageUrlAdvertisments = (uri) => {
    if(!uri || uri.indexOf('http') == 0) {
        return uri
    }
    let parts = uri.split('public://');
    

    if (parts.length==2) {
        return 'https://www.colfisiocv.com/sites/default/files/styles/large_retina/public/' + parts[1];
    } 

    return '';
}


const downloadFile = (uri) => {
    if (cordova.isApp()) {
        cordova.openExternalUrl(uri);
    }
    else
    {
        window.open(uri,'_blank')
    }
}

const openExternalUrl = (uri) => {
    if (cordova.isApp()) {
        cordova.openExternalUrl(uri);
    }
    else
    {
        window.open(uri,'_blank')
    }
}

// Para navegaciones tras llamadas de red (p. ej. el checkout de Stripe): un
// window.open en ese punto lo bloquea el navegador si la activación del clic
// ya ha caducado; navegar en la misma pestaña no está sujeto al bloqueador.
const openExternalUrlInSameTab = (uri) => {
    if (cordova.isApp()) {
        cordova.openExternalUrl(uri);
    }
    else
    {
        window.location.assign(uri)
    }
}

export default {
    getLargeImageUrl,
    downloadFile,
    openExternalUrl,
    openExternalUrlInSameTab,
    getLargeImageUrlAdvertisments
  }